import { useState } from "react";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { toast } from "react-toastify";

const contactData = [
  {
    id: 1,
    name: "Call Us",
    info: "+91 70497 47730",
    link: "tel:+917049747730",
    icon: <FaPhoneAlt className="text-4xl text-yellow-500 mb-3" />,
  },
  {
    id: 2,
    name: "Email",
    info: "shrijigirlhostel@gmail.com",
    icon: <FaEnvelope className="text-4xl text-blue-500 mb-3" />,
  },
  {
    id: 3,
    name: "Location",
    info: "Ashok Nagar, Bhanwarkua Main Road, Indore - 452001",
    icon: <FaMapMarkerAlt className="text-4xl text-red-500 mb-3" />,
  },
];

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const scriptURL = process.env.REACT_APP_SCRIPT_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.info("Sending message...");
    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach((key) => {
        formDataToSend.append(key, formData[key]);
      });

      const response = await fetch(scriptURL, {
        method: "POST",
        body: formDataToSend,
      });

      if (response.ok) {
        toast.success("Message sent successfully!");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        toast.error("Server error");
      }
    } catch (error) {
      toast.error("Failed to send message");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      {/* Hero */}
      <div className="relative h-[40vh] flex items-center justify-center">
        <img
          src="/images/contact/contact1.webp"
          alt="Girls Hostel in Bhanwarkua Indore"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40"></div>
        <h1 className="relative text-4xl md:text-6xl font-bold text-white text-center px-4">
          Contact Shri Ji Girls Hostel
        </h1>
      </div>

      {/* Contact Cards */}
      <section className="py-12">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 px-4">
          {contactData.map((item) => (
            <div
              key={item.id}
              className="bg-white shadow-lg rounded-2xl p-6 flex flex-col items-center text-center hover:scale-105 transition"
            >
              {item.icon}
              <h3 className="font-bold text-lg">{item.name}</h3>

              {item.link ? (
                <a
                  href={item.link}
                  className="text-gray-600 text-sm hover:text-pink-600"
                >
                  {item.info}
                </a>
              ) : (
                <p className="text-gray-600 text-sm">{item.info}</p>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <div className="text-center mb-8">
        <a
          href="https://wa.me/917049747730"
          className="bg-green-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-600"
        >
          Book on WhatsApp Instantly
        </a>
      </div>

      {/* Form + Map */}
      <section className="py-12 bg-white">
        <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-8">
          
          {/* Form */}
          <div>
            <h2 className="text-3xl font-bold text-pink-600 mb-8">
              Send Us a Message
            </h2>

            <form className="grid gap-6" onSubmit={handleSubmit}>
              <input name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required className="border px-4 py-2 rounded" />
              <input name="email" type="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required className="border px-4 py-2 rounded" />
              <input name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange} className="border px-4 py-2 rounded" />
              <textarea name="message" rows="5" placeholder="Your Message" value={formData.message} onChange={handleChange} required className="border px-4 py-2 rounded"></textarea>

              <button className="bg-pink-600 text-white py-3 rounded-lg hover:bg-pink-500">
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

          {/* Map */}
          <div>
            <h2 className="text-3xl font-bold text-pink-600 mb-6">
              Our Location
            </h2>

            <iframe
              title="Shri Ji Girls Hostel Bhanwarkua Indore"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.872506794114!2d75.86296767507498!3d22.69556577940909!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962fd4a59bb9ae7%3A0xb31ff590905fa486!2sShri%20Ji%20Girls%20Hostel%20Indore!5e0!3m2!1sen!2sin!4v1693833989872!5m2!1sen!2sin"
              className="w-full h-96 border-0 rounded-2xl shadow-lg"
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}
